module.exports = __webpack_public_path__ + "img/11.a759ca87.jpg";